import React, { useContext, useEffect } from 'react'
import { AutoConfigWrapper } from './AutoConfigStyles'
import { AutoConfigProps } from './Interface'
import Switchers from './components/switchers/Switchers'
import Configs from './components/configs/Configs'
import ActionButtons from './components/actionButtons/ActionButtons'
import AutoInputs from './components/inputs/autoInputs'
import { MyContext } from '../../../context/createContext'

export default function AutoConfig({
  handleStateUpdate,
  handleAutoReady,
  handleAutoConfigs,
  handleStartAuto,
  handleManual,
  audio,
  handleSaveConfig,
  handleConfig,
  autoData,
  active,
  handleonWin,
  handleonLoss,
  prec,
}: // onWin,
// onLoss,
AutoConfigProps) {
  const {
    maxStake,
    onLoss,
    onWin,
    onLossPercent,
    onWinPercent,
    rollAmount,
    stopOnLoss,
    stopOnWin,
  } = autoData

  const { context } = useContext(MyContext)
  const {
    config,
    rollUnder,
    autoConfigOne,
    autoConfigTwo,
    autoConfigThree,
    handleNotification,
    auth,
  } = context

  const { maxbet } = config

  const {
    balance: { currency },
  } = auth

  return (
    <AutoConfigWrapper>
      <AutoInputs
        currency={currency}
        handleStateUpdate={handleStateUpdate}
        rollAmount={rollAmount}
        autoMaxStake={maxStake}
        maxbet={maxbet}
        stopOnLoss={stopOnLoss}
        stopOnProfit={stopOnWin}
        handleNotification={handleNotification}
        prec={prec}
      />
      <Switchers
        onWin={onWin}
        onLoss={onLoss}
        onWinPercent={onWinPercent}
        onLossPercent={onLossPercent}
        handleStateUpdate={handleStateUpdate}
        audio={audio}
        handleonWin={handleonWin}
        handleonLoss={handleonLoss}
      />
      <ActionButtons
        rollUnder={rollUnder}
        handleAutoReady={handleAutoReady}
        handleAutoConfigs={handleAutoConfigs}
        handleStartAuto={handleStartAuto}
        handleManual={handleManual}
        audio={audio}
        handleSaveConfig={handleSaveConfig}
      />
      <Configs
        configOne={autoConfigOne}
        configTwo={autoConfigTwo}
        configThree={autoConfigThree}
        handleConfig={handleConfig}
        active={active}
      />
    </AutoConfigWrapper>
  )
}
